export const DEFAULT_PAGE_INDEX = 1;
